module.exports = __webpack_public_path__ + "static/05-5ef3010a82ac431433992660594ef0a5.jpg";